import api from './api';

const alertSettingsService = {
  getSettings: () => api.get('/alert-settings'),
  updateSettings: (settings) => api.put('/alert-settings', { settings })
};

export default alertSettingsService;
